import { List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'

const columnsAllowed= [
    {
        name: 'Factura',
        type: 'Obligatorio',
    },
    {
        name: 'Codigo del Prestador',
        type: 'Obligatorio',
    },
    {
        name: 'Valor pagado',
        type: 'Obligatorio',
    },
    {
        name: 'CDP',
        type: 'Obligatorio',
    },
    {
        name: 'RPC',
        type: 'Obligatorio',
    },
    {
        name: 'RESOLUCION',
        type: 'No obligatorio',
    },
    {
        name: 'N° DOC PAGO (TD)',
        type: 'Obligatorio',
    },
    {
        name: 'RUBRO',
        type: 'Obligatorio',
    },
    {
        name: 'FECHA DE PAGO',
        type: 'Obligatorio',
    },
    {
        name: 'Nombre_documento_de_pago',
        type: 'Obligatorio, debe coincidir con el nombre del archivo pdf',
    },
]

export const HeaderTooltip = () => {
    return (
      <section>
        <Typography data-testid='title_tooltip' className='fs-10'> Carga un archivo Excel con las siguientes columnas: </Typography>
        <div>
            {columnsAllowed.map((value) => (
                <li
                key={value.name}
                >
                    <span className='fs-10 fs-bold'>{value.name}: </span> <span className='fs-10'>{value.type}</span>
                </li>
            ))}
        </div>
      </section>
    )
  
}
